/**
 * Plugin for math equations: treats equation nodes as inline or void elements
 * @param {Editor} editor - Slate editor instance
 * @returns {Editor} Extended editor with equation handling
 */
const withEquation = (editor) => {
    const { isInline } = editor;
    editor.isInline = (element) => (element.type === 'equation' && element.inline ? true : isInline(element));
    return editor;
};

export default withEquation;
